<template>
  <div class="merchant-app-section equipment-information">
    <div class="row">
      <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
        <p class="merchant-app-section-title">Supporting Documents</p>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
        <p class="fields-completed-count">
          {{ countNull(documentationsVal) }}/
          {{ Object.keys(documentationsVal).length }}
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <div class="merchant-app-field">
          <label>Drivers License</label>
          <div v-if="documentationsVal.driver_license_val">
            <a :href="documentationsVal.driver_license_val" class="view-document" target="_blank" download>
              <i class="fas fa-external-link-alt"></i> View document
            </a>
            <a class="delete-document" @click="deleteFile('driver_license_val')">
              <i class="fas fa-trash-alt"></i> Delete
            </a>
          </div>
          <b-form-file
            v-else
            v-model="documentationsForms.driver_license"
            :state="Boolean(documentationsVal.driver_license_val)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </div>

        <div class="merchant-app-field">
          <label>Articles of Incorporation</label>
          <div v-if="documentationsVal.articles_of_incorporation_val">
            <a
              :href="documentationsVal.articles_of_incorporation_val"
              class="view-document"
              download
            >
              <i class="fas fa-external-link-alt"></i> View document
            </a>
            <a class="delete-document" @click="deleteFile('articles_of_incorporation_val')">
              <i class="fas fa-trash-alt"></i> Delete
            </a>
          </div>
          <b-form-file
            v-else
            v-model="documentationsForms.articles_of_incorporation"
            :state="Boolean(documentationsVal.articles_of_incorporation_val)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </div>

        <div class="merchant-app-field last-field-left">
          <label>(4) Months of Bank Statements</label>
          <div v-if="documentationsVal.months_of_bank_statements_val">
            <a
              :href="documentationsVal.months_of_bank_statements_val"
              class="view-document"
              download
            >
              <i class="fas fa-external-link-alt"></i> View document
            </a>
            <a class="delete-document" @click="deleteFile('months_of_bank_statements_val')">
              <i class="fas fa-trash-alt"></i> Delete
            </a>
          </div>
          <b-form-file
            v-else
            v-model="documentationsForms.months_of_bank_statements"
            :state="Boolean(documentationsVal.months_of_bank_statements_val)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </div>
      </div>

      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
        <div class="merchant-app-field">
          <label>Voided Check</label>
          <div v-if="documentationsVal.voided_check_val">
            <a :href="documentationsVal.voided_check_val" class="view-document"  download>
              <i class="fas fa-external-link-alt"></i> View document
            </a>
            <a class="delete-document" @click="deleteFile('voided_check_val')">
              <i class="fas fa-trash-alt"></i> Delete
            </a>
          </div>

          <b-form-file
            v-else
            v-model="documentationsForms.voided_check"
            :state="Boolean(documentationsVal.voided_check_val)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </div>
        <div class="merchant-app-field last-field-right">
          <label>(4) Months of Processing Statements</label>
          <div v-if="documentationsVal.months_of_processing_statements_val">
            <a
              :href="documentationsVal.months_of_processing_statements_val"
              class="view-document"
              download
            >
              <i class="fas fa-external-link-alt"></i> View document
            </a>
            <a class="delete-document" target="_blank" @click="deleteFile('months_of_processing_statements_val')">
              <i class="fas fa-trash-alt"></i> Delete
            </a>
          </div>
          <b-form-file
            v-else
            v-model="documentationsForms.months_of_processing_statements"
            :state="Boolean(documentationsVal.months_of_processing_statements_val)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Axios from "axios";
import helper from '@/helper/helper';
export default {
  mixins:[helper],
  props: ["save"],
  events: {
    save_document: function() {
      this.put_document();
    }
  },
  computed: {
    appCode () {
      return this.$store.state.appCode?this.$store.state.appCode:this.$route.params.key
    },
    accessToken () {
      return this.$store.state.accessToken
    },
  },
  data() {
    return {
      requirements: {
        document_id: null
      },
      documentationsForms: {
        driver_license: null,
        articles_of_incorporation: null,
        months_of_bank_statements: null,
        voided_check: null,
        months_of_processing_statements: null,
      },
      documentationsVal:{
        driver_license_val: null,
        articles_of_incorporation_val: null,
        months_of_bank_statements_val: null,
        voided_check_val: null,
        months_of_processing_statements_val: null
      }
    };
  },
  methods: {
    countNull(obj) {
      let result = 0;
      for (let i in obj) {
        if (obj[i] && obj[i] != null) {
          result++;
        }
      }
      return result;
    },
    get_filledField(){
      var res =this.countNull(this.documentationsVal) + this.countNull(this.documentationsForms)
      return res
    },
    get_field(){
      return this.documentationsVal
    },
    get_document() {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken
        }
      };
      Axios.get(`applications/docs/${this.appCode}/`, config)
        .then(response => {
          if (response.status == 200) {
            this.documentationsVal.driver_license_val =
              response.data.driver_license;
            this.documentationsVal.articles_of_incorporation_val =
              response.data.Articles_of_Incorporation;
            this.documentationsVal.months_of_bank_statements_val =
              response.data.Months_of_Bank_Statements;
            this.documentationsVal.voided_check_val =
              response.data.Voided_Check;
            this.documentationsVal.months_of_processing_statements_val =
              response.data.Months_of_Processing_Statements;
            this.requirements.document_id = response.data.id;
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    put_document() {
      const config = {
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW",
          Authorization: "Bearer " + this.accessToken
        }
      };
      var Form = new FormData();

      if (this.documentationsForms.driver_license) {
        Form.append("driver_license", this.documentationsForms.driver_license);
      } else if (!this.documentationsVal.driver_license_val) {
        Form.append("driver_license", []);
      }
      if (this.documentationsForms.articles_of_incorporation) {
        Form.append(
          "Articles_of_Incorporation",
          this.documentationsForms.articles_of_incorporation
        );
      } else if (!this.documentationsVal.articles_of_incorporation_val) {
        Form.append("Articles_of_Incorporation", []);
      }
      if (this.documentationsForms.months_of_bank_statements) {
        Form.append(
          "Months_of_Bank_Statements",
          this.documentationsForms.months_of_bank_statements
        );
      } else if (!this.documentationsVal.months_of_bank_statements_val) {
        Form.append("Months_of_Bank_Statements", []);
      }
      if (this.documentationsForms.voided_check) {
        Form.append("Voided_Check", this.documentationsForms.voided_check);
      } else if (!this.documentationsVal.voided_check_val) {
        Form.append("Voided_Check", []);
      }
      if (this.documentationsForms.months_of_processing_statements) {
        Form.append(
          "Months_of_Processing_Statements",
          this.documentationsForms.months_of_processing_statements
        );
      } else if (
        !this.documentationsVal.months_of_processing_statements_val
      ) {
        Form.append("Months_of_Processing_Statements", []);
      }
      Form.append("app", this.appCode);
      Axios.put(`applications/docs/${this.appCode}/`, Form, config)
        .then(response => {
          // Display the key/value pairs
 
          if (response.status == 200) {
            this.get_document();
            this.documentationsForms = {
              driver_license: null,
              articles_of_incorporation: null,
              months_of_bank_statements: null,
              voided_check: null,
              months_of_processing_statements: null,
            };
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteFile(keys) {
      var keysForm = keys.replace('_val','');
      var stateVal = this.documentationsVal;
      var stateForm = this.documentationsForms;
      stateVal[keys] = null;
      stateForm[keysForm] = null;
    }
  },
  async created() {
    await this.get_document();
  },
  watch: {
    documentationsForms: function(updated, old) {
      if (updated) {
        this.documentationsForms = updated;
      }
    },
  },
  mounted() {
    this.$store.dispatch("setDocument",this.documentationsVal)
  },
};
</script>

<style>
.view-document {
  font-size: 18px;
  display: inline-block;
  color: white !important;
  background: #673ab7;
  padding: 5px 15px;
  border-radius: 4px;
}

.delete-document {
  font-size: 18px;
  margin-left: 10px;
  display: inline-block;
  color: white !important;
  background: #f44336;
  padding: 5px 15px;
  border-radius: 4px;
}

.view-document:hover {
  background: #512da8;
  text-decoration: none;
}

.delete-document:hover {
  background: #d32f2f;
  text-decoration: none;
}
</style>